<template>
  <AtomsCommonContentTitle :title="title" />
</template>

<script>
import AtomsCommonContentTitle from "@/components/atoms/privateCruising/ContentTitle.vue";
export default {
  components: {
    AtomsCommonContentTitle,
  },
  props: {
    title: String,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/molecules/privateCruising/contentTitleRed.scss";
</style>
